// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7894c14a","208":"f0e15536","255":"72b3f317","380":"0f2766ef","610":"f58b391f","638":"d7121c86","690":"0fe41d68"}[chunkId] + ".chunk.js";
};